import React, { useState, useEffect } from "react";
import { Button, RoomCard, FormRow, Alert } from "../../components";
import { useNavigate } from "react-router-dom";
import socket from "../../socket";
import { useDispatch, useSelector } from "react-redux";
import { displayAlert, tempUser } from "../../actions";
import "./styles.css";

const LobbyPage = () => {
	const [choice, setChoice] = useState("");
	const [tempUsername, setTempUsername] = useState("");
	const [rooms, setRooms] = useState([]);
	const user = useSelector((state) => state.registeredUser.user);
	const showAlert = useSelector((state) => state.registeredUser.showAlert);

	const navigator = useNavigate();
	const dispatch = useDispatch();

	const handleClick = (choice) => {
		setChoice(choice);
	};

	const handleChange = (e) => {
		setTempUsername(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!tempUsername) {
			dispatch(displayAlert());
			setTimeout(() => {
				dispatch({
					type: "CLEAR_ALERT"
				});
			}, 2000);
			return;
		} else {
			socket.auth = {
				username: tempUsername
			};
			socket.connect();
			dispatch(tempUser(tempUsername));
		}
	};

	const handleLogin = () => {
		navigator("../register");
	};

	const handleBack = () => {
		setChoice("");
	};

	const handleCreateRoom = () => {
		socket.emit("load rooms");
		const roomIds = rooms.map((room) => room.name);
		let roomId = Math.ceil(Math.random() * 500).toString();
		while (roomIds.includes(roomId)) {
			roomId = Math.ceil(Math.random() * 500).toString();
		}
		socket.emit("create room", roomId);
		navigator(`../room/${roomId}`);
	};

	const handleLoadRooms = () => {
		socket.emit("load rooms");
	};

	useEffect(() => {
		socket.on("rooms", (data) => {
			setRooms(data);
		});
		return () => socket.off("rooms");
	}, []);

	useEffect(() => {
		user ? setChoice("") : setChoice("NOT_LOGGED_IN");
	}, [user]);

	const renderChoice = (choice) => {
		switch (choice) {
			case "JOIN_ROOM":
				return (
					<>
						{rooms.length > 0 ? (
							<div className="roomContainer">
								<Button
									onClick={() => {
										handleBack();
									}}
									text={
										<>
											Go Back<span></span>
											<span class="cybrBtnGlitch">Go Back</span>
										</>
									}
								/>
								<div className="roomWrapper">
									{rooms.map((room) => {
										return <RoomCard name={room.name} users={room.users} />;
									})}
								</div>
							</div>
						) : (
							<>
								<div className="createContainer">
									<div className="createWrapper">
										<h1>There are no rooms available at this time</h1>
										<Button
											onClick={() => {
												handleBack();
											}}
											text={
												<>
													Go Back<span></span>
													<span class="cybrBtnGlitch">Go Back</span>
												</>
											}
										/>
									</div>
								</div>
							</>
						)}
					</>
				);
			case "NOT_LOGGED_IN":
				return (
					<>
						<div className="tempContainer">
							<div className="tempWrapper">
								<h1>to access the game rooms</h1>
								<h2>please log in</h2>
								<Button
									text={
										<>
											Log In<span aria-hidden></span>
											<span aria-hidden class="cybrBtnGlitch">
												Log In
											</span>
										</>
									}
									onClick={handleLogin}
								/>
								<h2>or create a temporary user</h2>
								{showAlert && <Alert />}
								<form onSubmit={handleSubmit} className="form">
									<FormRow
										type="text"
										name="username"
										value={tempUsername}
										htmlFor="username"
										handleChange={handleChange}
									/>
									<Button
										type="submit"
										text={
											<>
												Submit<span aria-hidden></span>
												<span aria-hidden class="cybrBtnGlitch">
													Submit
												</span>
											</>
										}
									/>
								</form>
							</div>
						</div>
					</>
				);
			default:
				return (
					<>
						<div className="createContainer">
							<div className="createWrapper">
								<h1>Create or Join a Room</h1>
								<div>
									<Button
										onClick={(e) => {
											handleCreateRoom(e);
										}}
										text={
											<>
												Create Room<span aria-hidden></span>
												<span aria-hidden class="cybrBtnGlitch">
													Create Room
												</span>
											</>
										}
									/>
									<Button
										onClick={(e) => {
											handleClick("JOIN_ROOM");
											handleLoadRooms(e);
										}}
										text={
											<>
												Join Room<span aria-hidden></span>
												<span aria-hidden class="cybrBtnGlitch">
													Join Room
												</span>
											</>
										}
									/>
								</div>
							</div>
						</div>
					</>
				);
		}
	};
	return <>{renderChoice(choice)}</>;
};

export default LobbyPage;
